import CoordModel from './coord';
var registedComponentModels = {
    coord: CoordModel,
};
export function registerComponent(componentName, model) {
    registedComponentModels[componentName] = model;
    model.type = componentName;
}
export function getRegisteredComponent(componentName) {
    return registedComponentModels[componentName];
}
